export default "__VITE_ASSET__BxxzRhCk__"